import { render, staticRenderFns } from "./IndexLeftInfo.vue?vue&type=template&id=29ed8210"
import script from "./IndexLeftInfo.vue?vue&type=script&lang=js"
export * from "./IndexLeftInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports